module.exports = __webpack_public_path__ + "img/img55.a5e385d8.jpg";